import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import { shape, string, node, bool, objectOf, any } from 'prop-types';

export const renderSelectField = ({
  input,
  label,
  meta: { touched, error },
  children,
  ...custom
}) => {
  return (
    <FormControl fullWidth error={touched && !!error}>
      <InputLabel htmlFor="appPkg-component-select">
        {label}
      </InputLabel>
      <Select
        inputProps={{
          id: 'appPkg-component-select'
        }}
        {...input}
        {...custom}
      >
        {children}
      </Select>
    </FormControl>
  );
};

renderSelectField.propTypes = {
  input: objectOf(any),
  meta: shape({
    touched: bool,
    error: string
  }),
  label: string,
  children: node
};

export const renderTextField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) =>
  <FormControl fullWidth error={touched && !!error}>
    <TextField
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...custom}
    />
  </FormControl>;

renderTextField.propTypes = {
  input: objectOf(any),
  meta: shape({
    touched: bool,
    error: string,
    invalid: bool
  }),
  label: string
};



// WEBPACK FOOTER //
// ./src/client/plugins/applications/components/packageFormFields/customFields.js